import { HttpStatus, OperationStatus, APIResponse } from "./Constants";
import { Strings } from "../Resources/Strings/i18n";

export const defaultErrorInfo = {
    errorCode: OperationStatus.FAILURE,
    errorMessage: Strings("ERROR_GENERIC"),
    errorTitle: "Error",
};

/* Error look-up method for mapping app level error information */
export default function getAppErrorInfo(errorCode) {
    let errorInfo = {};
    errorInfo.errorCode = errorCode;
    errorInfo.errorTitle = "Error";

    switch (errorCode) {
        case OperationStatus.NETWORK_NOT_REACHABLE: //2
            errorInfo.errorMessage = Strings("NetworkNotReachable");
            errorInfo.errorTitle = "NetworkUnavailable";
            break;

        case OperationStatus.DEVICE_REGISTRATION_FAILED_FOR_PUSH_NOTIFICATION: //3
            errorInfo.errorMessage = Strings(
                "ERROR_DEVICE_REGISTRATION_FAILED_FOR_PUSH_NOTIFICATION"
            );
            break;

        case OperationStatus.REQUEST_TIMEOUT: //4
            errorInfo.errorMessage = Strings("ERROR_REQUEST_TIMEOUT");
            break;

        case OperationStatus.DB_HANDLER_FAILURE: //5
            errorInfo.errorMessage = Strings("ERROR_DB_HANDLER_FAILURE");
            break;

        case OperationStatus.MANDATORY_FIELDS_CANT_BE_EMPTY: //7
            errorInfo.errorMessage = Strings(
                "ERROR_MANDATORY_FIELDS_CANT_BE_EMPTY"
            );
            break;

        default:
            defaultErrorInfo.errorCode = errorCode;
            errorInfo = defaultErrorInfo;
    }

    return errorInfo;
}

//
// Error look-up method for mapping error retured from APIs
//
export function getAPIErrorInfo(errorCode) {
    let errorInfo = defaultErrorInfo;
    let errCode = defaultErrorInfo.errorCode.toString();

    if (errorCode) {
        errCode = errorCode;
        errorInfo.errorCode = parseInt(errCode);
    }

    //  ;

    switch (errCode) {
        //HTTP error status
        case HttpStatus.BAD_REQUEST: //400
            errorInfo.errorMessage = Strings("ERROR_BAD_REQUEST");
            break;

        case HttpStatus.UNAUTHORIZED: //401
            errorInfo.errorMessage = Strings("ERROR_ACCESS_DENIED");
            break;

        case HttpStatus.RESOURCE_NOT_FOUND: //404
            errorInfo.errorMessage = Strings("ERROR_RESOURCE_NOT_FOUND");
            break;

        case HttpStatus.INTERNAL_SERVER_ERROR: //500
            errorInfo.errorMessage = Strings("INTERNAL_SERVER_ERROR");
            break;

        //NEW APIs Errors
        case APIResponse.APPLICATION_ERROR: //1001
            errorInfo.errorMessage = Strings("ERROR_APPLICATION_ERROR");
            break;

        case APIResponse.ACCOUNT_ALREADY_EXIST: //1002
            errorInfo.errorMessage = Strings("ERROR_USER_ALREADY_EXISTS");
            break;

        case APIResponse.ACCOUNT_ALREADY_REGISTERED: //1004
            errorInfo.errorMessage = Strings("ERROR_USER_ALREADY_REGISTERED");
            break;

        case APIResponse.USER_NOT_FOUND: //1006
            errorInfo.errorMessage = Strings("ERROR_USER_NOT_FOUND");
            break;

        case APIResponse.JWT_TOKEN_EXPIRED: //1007
            errorInfo.errorMessage = Strings("ERROR_JWT_TOKEN_EXPIRED");
            break;

        case APIResponse.INVALID_JWT_TOKEN: //1008
            errorInfo.errorMessage = Strings("ERROR_INVALID_JWT_TOKEN");
            break;

        case APIResponse.REQUEST_FIELD_NOT_PRESENT_OR_INVALID: //1013
            errorInfo.errorMessage = Strings(
                "ERROR_FIELD_NOT_PRESENT_OR_INVALID"
            );
            break;

        case APIResponse.INVALID_DEVICE_TYPE: //1014
            errorInfo.errorMessage = Strings("ERROR_INVALID_DEVICE_TYPE");
            break;
        case APIResponse.INVALID_USER_AGENT: //1015
            errorInfo.errorMessage = Strings("ERROR_INVALID_USER_AGENT");
            break;

        case APIResponse.EMAIL_ALREADY_EXISTS: //1016
            errorInfo.errorMessage = Strings("ERROR_EMAIL_ALREADY_EXISTS");
            break;
        case APIResponse.WEB_CONSOLE_LOGIN_NOT_ALLOWED: //1017
            errorInfo.errorMessage = Strings("WEB_CONSOLE_LOGIN_NOT_ALLOWED");
            break;
        case APIResponse.INVALID_FIRST_NAME: //2001
            errorInfo.errorMessage = Strings("ERROR_INVALID_FIRST_NAME");
            break;

        case APIResponse.INVALID_LAST_NAME: //2002
            errorInfo.errorMessage = Strings("ERROR_INVALID_LAST_NAME");
            break;

        case APIResponse.INVALID_MOBILE_NUMBER: //2005
            errorInfo.errorMessage = Strings("ERROR_INVALID_MOBILE_NUMBER");
            break;

        case APIResponse.INVALID_TIMEZONE: //2013
            errorInfo.errorMessage = Strings("ERROR_INVALID_TIMEZONE");
            break;

        case APIResponse.INVALID_AUTH_GRANT: //2014
            errorInfo.errorMessage = Strings("ERROR_INVALID_AUTH_GRANT");
            break;

        case APIResponse.INVALID_ARGUMENT: //2015
            errorInfo.errorMessage = Strings("ERROR_INVALID_ARGUMENT");
            break;

        case APIResponse.ACCESS_DENIED_ERROR: //2016
            errorInfo.errorMessage = Strings("ERROR_ACCESS_DENIED");
            break;

        case APIResponse.INVALID_CLIENT: //2017
            errorInfo.errorMessage = Strings("ERROR_INVALID_CLIENT");
            break;

        case APIResponse.INVALID_REQUEST: //2018
            errorInfo.errorMessage = Strings("ERROR_INVALID_REQUEST");
            break;

        case APIResponse.INSUFFIECIENT_SCOPE: //2019
            errorInfo.errorMessage = Strings("ERROR_INSUFFICIENT_SCOPE");
            break;

        case APIResponse.INVALID_SCOPE: //2020
            errorInfo.errorMessage = Strings("ERROR_INVALID_SCOPE");
            break;

        case APIResponse.UNAUTHORIZED_CLIENT: //2021
            errorInfo.errorMessage = Strings("ERROR_UNAUTHORIZED_CLIENT");
            break;

        case APIResponse.UNAUTHORIZED_REQUEST: //2022
            errorInfo.errorMessage = Strings("ERROR_UNAUTHORIZED_REQUEST");
            break;

        case APIResponse.UNSUPPORTED_GRANT_TYPE: //2023
            errorInfo.errorMessage = Strings("ERROR_UNSUPPORTED_GRANT_TYPE");
            break;

        case APIResponse.UNSUPPORTED_RESPONSE_TYPE: //2024
            errorInfo.errorMessage = Strings("ERROR_UNSUPPORTED_RESPONSE_TYPE");
            break;

        case APIResponse.SERVER_ERROR: //2025
            errorInfo.errorMessage = Strings("ERROR_SERVER_ERROR");
            break;

        case APIResponse.INVALID_COUNTRY_CALLING_CODE: //2027
            errorInfo.errorMessage = Strings("ERROR_INVALID_CALLING_CODE");
            break;

        case APIResponse.INVALID_REFRESH_TOKEN: //2029
            errorInfo.errorMessage = Strings("ERROR_INVALID_REFRESH_TOKEN");
            break;

        case APIResponse.INVALID_CLIENT_ID: //2030
            errorInfo.errorMessage = Strings("ERROR_INVALID_CLIENT_ID");
            break;

        case APIResponse.INVALID_CLIENT_SECRET_KEY: //2031
            errorInfo.errorMessage = Strings("ERROR_INVALID_CLIENT_SECRET_KEY");
            break;

        case APIResponse.INVALID_DEVICE_TOKEN: //2032
            errorInfo.errorMessage = Strings("ERROR_INVALID_DEVICE_TOKEN");
            break;

        case APIResponse.INVALID_USER_ID: //2033
            errorInfo.errorMessage = Strings("ERROR_INVALID_USER_ID");
            break;

        case APIResponse.INVALID_USER_PROFILE: //2034
            errorInfo.errorMessage = Strings("ERROR_INVALID_USER_PROFILE");
            break;

        case APIResponse.OPERATION_NOT_ALLOWED: //2035
            errorInfo.errorMessage = Strings("ERROR_OPERATION_NOT_ALLOWED");
            break;

        case APIResponse.INVALID_INVITE_ID: //2037
            errorInfo.errorMessage = Strings("ERROR_INVALID_INVITE_ID");
            break;

        case APIResponse.INVALID_INVITATION: //2038
            errorInfo.errorMessage = Strings("ERROR_INVALID_INVITATION");
            break;

        case APIResponse.INVITATION_DOESNOT_BELONG_TO_USER: //2039
            errorInfo.errorMessage = Strings(
                "ERROR_INVITATION_DOESNOT_BELONG_TO_USER"
            );
            break;

        case APIResponse.INVALID_PARAMETER_ID: //2042
            errorInfo.errorMessage = Strings("ERROR_INVALID_PARAMETER_ID");
            break;

        case APIResponse.INVALID_PARAMETER_NAME: //2044
            errorInfo.errorMessage = Strings("ERROR_INVALID_PARAMETER_NAME");
            break;

        case APIResponse.INVALID_RECORDED_TIMESTAMP: //2049
            errorInfo.errorMessage = Strings(
                "ERROR_INVALID_RECORDED_TIMESTAMP"
            );
            break;

        case APIResponse.INVALID_GRANT_TYPE: //2056
            errorInfo.errorMessage = Strings("ERROR_INVALID_GRANT_TYPE");
            break;

        case APIResponse.INVALID_VALUE: //2057
            errorInfo.errorMessage = Strings("ERROR_INVALID_VALUE");
            break;

        case APIResponse.SUMMARY_NOT_FOUND: //2058
            errorInfo.errorMessage = Strings("ERROR_SUMMARY_DATA_NOT_FOUND");
            break;

        case APIResponse.INVALID_FOR_DATE: //2059
            errorInfo.errorMessage = Strings("ERROR_INVALID_FOR_DATE");
            break;

        case APIResponse.INVALID_FOR_USER_ID: //2062
            errorInfo.errorMessage = Strings("ERROR_INVALID_REQUESTED_USER_ID");
            break;

        case APIResponse.MAPPING_NOT_FOUND: //2063
            errorInfo.errorMessage = Strings("ERROR_MAPPING_NOT_FOUND");
            break;

        case APIResponse.INVALID_MAX_VALUE: //2064
            errorInfo.errorMessage = Strings("ERROR_INVALID_MAX_VALUE");
            break;

        case APIResponse.INVALID_MIN_VALUE: //2065
            errorInfo.errorMessage = Strings("ERROR_INVALID_MIN_VALUE");
            break;

        case APIResponse.INVALID_AVG_VALUE: //2066
            errorInfo.errorMessage = Strings("ERROR_INVALID_AVG_VALUE");
            break;

        case APIResponse.INVALID_START_TIME: //2067
            errorInfo.errorMessage = Strings("ERROR_INVALID_START_TIME");
            break;

        case APIResponse.INVALID_END_TIME: //2068
            errorInfo.errorMessage = Strings("ERROR_INVALID_END_TIME");
            break;

        case APIResponse.INVALID_INTERVAL: //2069
            errorInfo.errorMessage = Strings("ERROR_INVALID_INTERVAL");
            break;

        case APIResponse.INVALID_USER_TYPE: //2070
            errorInfo.errorMessage = Strings("ERROR_INVALID_USER_TYPE");
            break;

        case APIResponse.INVALID_PARAMETERS: //2071
            errorInfo.errorMessage = Strings("ERROR_INVALID_PARAMETERS");
            break;

        case APIResponse.INVALID_TRANSACTION_ID: //2072
            errorInfo.errorMessage = Strings("ERROR_INVALID_TRANSACTION_ID");
            break;

        case APIResponse.MONITERING_USERS_NOT_FOUND: //2073
            errorInfo.errorMessage = Strings(
                "ERROR_MONITORING_USERS_NOT_FOUND"
            );
            break;

        case APIResponse.INVALID_RELATIONSHIP: //2074
            errorInfo.errorMessage = Strings("ERROR_INVALID_RELATIONSHIP");
            break;

        case APIResponse.EMAIL_SENT_FAILURE_TO_PRECONFIGURED_SUPPORT_EMAIL_ID: //2078
            errorInfo.errorMessage = Strings(
                "ERROR_EMAIL_SENT_FAILURE_TO_PRECONFIGURED_SUPPORT_EMAIL_ID"
            );
            break;

        case APIResponse.INVALID_EMAIL_SUBJECT: //2079
            errorInfo.errorMessage = Strings("ERROR_INVALID_EMAIL_SUBJECT");
            break;

        case APIResponse.INVALID_EMAIL_MESSAGE: //2080
            errorInfo.errorMessage = Strings("ERROR_INVALID_EMAIL_MESSAGE");
            break;

        case APIResponse.INVALID_EMAIL_TOPIC: //2084
            errorInfo.errorMessage = Strings("ERROR_INVALID_EMAIL_TOPIC");
            break;

        case APIResponse.INVALID_BIRTH_YEAR: //2092
            errorInfo.errorMessage = Strings("ERROR_INVALID_BIRTH_YEAR∏");
            break;

        case APIResponse.UNSPPORTED_APP_VERSION: //3000
            errorInfo.errorMessage = Strings("ERROR_UNSUPPORTED_APP_VERSION");
            errorInfo.errorTitle = "UPGRADE_AVAILABLE_TITLE";
            break;

        case APIResponse.CONN_NOT_FOUND: //3001
            errorInfo.errorMessage = Strings("ERROR_CONN_NOT_FOUND");
            break;

        case APIResponse.PAID_CONN_CANNOT_REM: //3002
            errorInfo.errorMessage = Strings("ERROR_PAID_CONN_CANNOT_REM");
            break;

        case APIResponse.INCOMING_TRANSACTION_ALREADY_ACTIVE: //2093
            errorInfo.errorMessage = Strings(
                "ERROR_INCOMING_TRANSACTION_ALREADY_ACTIVE"
            );
            break;

        case APIResponse.INCOMING_TRANSACTION_ALREADY_COMPLETED: //2094
            errorInfo.errorMessage = Strings(
                "ERROR_INCOMING_TRANSACTION_ALREADY_COMPLETED"
            );
            break;

        case APIResponse.INCOMING_PAYMENT_REQUEST_FAILED: //2095
            errorInfo.errorMessage = Strings(
                "ERROR_INCOMING_PAYMENT_REQUEST_FAILED"
            );
            break;

        case APIResponse.IN_APP_PRODUCT_ID_DOESNNOT_EXISTS: //2096
            errorInfo.errorMessage = Strings(
                "ERROR_IN_APP_PRODUCT_ID_DOESNNOT_EXISTS"
            );
            break;

        case APIResponse.INVALID_PAYMENT_METHOD_USER: //2097
            errorInfo.errorMessage = Strings(
                "ERROR_INVALID_PAYMENT_METHOD_USER"
            );
            break;

        case APIResponse.PAYMENT_METHOD_DOESNOT_MATCH_DEFAULT_METHOD: //2098
            errorInfo.errorMessage = Strings(
                "ERROR_PAYMENT_METHOD_DOESNOT_MATCH_DEFAULT_METHOD"
            );
            break;

        case APIResponse.UNSUBSCRIBE_REQUEST_IS_INVALID: //2099
            errorInfo.errorMessage = Strings(
                "ERROR_UNSUBSCRIBE_REQUEST_IS_INVALID"
            );
            break;

        case APIResponse.INVALID_SUBSCRIPTION_ID_FOR_UNSUBSCRIPTION: //2100
            errorInfo.errorMessage = Strings(
                "ERROR_INVALID_SUBSCRIPTION_ID_FOR_UNSUBSCRIPTION"
            );
            break;

        case APIResponse.UNSUBSCRIPTION_WAS_UNSUCCESSFUL: //2102
            errorInfo.errorMessage = Strings(
                "ERROR_UNSUBSCRIPTION_WAS_UNSUCCESSFUL"
            );
            break;

        case APIResponse.INVALID_PLAN_ID_FOR_STRIPE_REQUEST: //2105
            errorInfo.errorMessage = Strings(
                "ERROR_INVALID_PLAN_ID_FOR_STRIPE_REQUEST"
            );
            break;

        case APIResponse.FAILED_TO_CREATE_SUBSCRIPTION: //2106
            errorInfo.errorMessage = Strings(
                "ERROR_FAILED_TO_CREATE_SUBSCRIPTION"
            );
            break;

        case APIResponse.INVALID_CONNECTIONS_FOR_SUBSCRIPTION: //2107
            errorInfo.errorMessage = Strings(
                "ERROR_INVALID_CONNECTIONS_FOR_SUBSCRIPTION"
            );
            break;

        case APIResponse.INVITATION_FROM_SUBSCRIPTION_ALREADY_PRESENT: //2120
            errorInfo.errorMessage = Strings(
                "ERROR_INVITATION_FROM_SUBSCRIPTION_ALREADY_PRESENT"
            );
            break;

        case APIResponse.INVALID_OTP: //2116
            errorInfo.errorMessage = Strings("ERROR_INVALID_OTP");
            break;

        case APIResponse.MOBILE_NUMBER_ALREADY_CONNECTED_TO_SENIOR: //2118
            errorInfo.errorMessage = Strings(
                "ERROR_MOBILE_NUMBER_ALREADY_CONNECTED_TO_SENIOR"
            );
            break;

        case APIResponse.USER_ALREADY_REGISTERED_AS_SENIOR:
            errorInfo.errorMessage = Strings(
                "ERROR_USER_ALREADY_REGISTERED_AS_SENIOR"
            );
            break;

        case APIResponse.INVALID_CARD_NUMBER:
            errorInfo.errorMessage = Strings("ERROR_INVALID_CARD_NUMBER");
            break;

        case APIResponse.COUPON_NOT_FOUND: //3012
            errorInfo.errorMessage = Strings("ERROR_COUPON_NOT_FOUND");
            break;

        case APIResponse.COUPON_LIMIT_EXCEEDED: // 3014
            errorInfo.errorMessage = Strings("ERROR_COUPON_LIMIT_EXCEEDED");
            break;

        case APIResponse.CANNOT_APPLY_COUPON: // 3016
            errorInfo.errorMessage = Strings("ERROR_CANNOT_APPLY_COUPON");
            break;

        case APIResponse.INVALID_WEB_TOKEN: // 3057
            errorInfo.errorMessage = Strings("ERROR_INVALID_WEB_TOKEN");
            break;
        case APIResponse.WEB_TOKEN_EXPIRED: // 3058
            errorInfo.errorMessage = Strings("ERROR_WEB_TOKEN_EXPIRED");
            break;
        case APIResponse.WEB_TOKEN_NOT_FOUND: // 3059
            errorInfo.errorMessage = Strings("ERROR_WEB_TOKEN_NOT_FOUND");
            break;
        case APIResponse.FAILED_TO_VERIFY_TOKEN: // 3062
            errorInfo.errorMessage = Strings("ERROR_FAILED_TO_VERIFY_TOKEN");
            break;
        case APIResponse.INVITATION_WITH_GIVEN_ID_NOT_FOUND: // 3055
            errorInfo.errorMessage = Strings("ERROR_INVITATION_WITH_GIVEN_ID_NOT_FOUND");
            break;
            // reports error
            case APIResponse.INVALID_REPORT_OF_USER: // 2122
            errorInfo.errorMessage = Strings("INVALID_REPORT_OF_USER");
            break;
            case APIResponse.INVALID_RECIPIENTS: // 2123
            errorInfo.errorMessage = Strings("INVALID_RECIPIENTS");
            break;
            case APIResponse.INVALID_RECIPIENT_NAME: // 2125
            errorInfo.errorMessage = Strings("INVALID_RECIPIENT_NAME");
            break;
            case APIResponse.INVALID_RECIPIENT_EMAIL: // 2126
            errorInfo.errorMessage = Strings("INVALID_RECIPIENT_EMAIL");
            break;
            case APIResponse.INVALID_REPORTS: // 2127
            errorInfo.errorMessage = Strings("INVALID_REPORTS");
            break;
            case APIResponse.INVALID_REPORT_RECIPIENT_ID: //2136
            errorInfo.errorMessage = Strings("INVALID_REPORT_RECIPIENT_ID");
            break;
            case APIResponse.INVALID_ID: // 2050
            errorInfo.errorMessage = Strings("INVALID_ID");
            break;
            case APIResponse.INVALID_NAME: // 2051
            errorInfo.errorMessage = Strings("INVALID_NAME");
            break;
            case APIResponse.INVALID_FREQUENCY: // 2128
            errorInfo.errorMessage = Strings("INVALID_FREQUENCY");
            break;
            case APIResponse.INVALID_DAY: // 2129
            errorInfo.errorMessage = Strings("INVALID_DAY");
            break;
            case APIResponse.INVALID_TIME: // 2121
            errorInfo.errorMessage = Strings("INVALID_TIME");
            break;
            case APIResponse.INVALID_DATE: // 2132
            errorInfo.errorMessage = Strings("INVALID_DATE");
            break;
            case APIResponse.INVALID_SCHEDULE_TYPE: // 2135
            errorInfo.errorMessage = Strings("INVALID_SCHEDULE_TYPE");
            break;
            case APIResponse.FAILED_TO_CREATE_REPORT: // 2134
            errorInfo.errorMessage = Strings("FAILED_TO_CREATE_REPORT");
            break;
            


            

            

        default:
            defaultErrorInfo.errorCode = errorCode;
            errorInfo = defaultErrorInfo;
    }

    return errorInfo;
}
